import React from "react"
import FormWrapper from "./FormWrapper"

export default function Add() {
  return (
    <div className="container">
      <h1>Add Organization</h1>
      <FormWrapper type="add" />
    </div>
  )
}
